export { default as ResetFooterComponent } from "./ResetFooterComponent";
